import React from "react";
import Header from "./header";
import AthleteprofileCard from "./AthleteprofileCard";
import ScoreTabContainer from "./ScoreTabContainer";
import ContentLister from "./ContentLister";
import ContentContainerTab from "./ContentContainerTab";
import { useAthleteProfile } from "../../api/athleteprofile/queryHooks";
import { useParams } from "react-router-dom";
import { decodeId } from "../../api/utils";

function AthleteprofilePage() {
  const id = decodeId(useParams()?.id);
  const { isError } = useAthleteProfile(id);

  if (isError) return <div>Not Found</div>;

  return (
    <>
      <Header />
      <AthleteprofileCard />
      <ScoreTabContainer />
      <ContentLister />
      <ContentContainerTab />
    </>
  );
}

export default AthleteprofilePage;
